import { ReportExportStatus } from '@prisma/client';
import { format } from 'date-fns';
import { ReportExport } from '../../types/reports';

export function formatExportDateRange(
  filters: ReportExport['filters'],
): string {
  if (!filters.startDate || !filters.endDate) return '—';
  const start = format(new Date(filters.startDate), 'MMM d, yyyy');
  const end = format(new Date(filters.endDate), 'MMM d, yyyy');
  return start === end ? start : `${start} – ${end}`;
}

export function isExportInFlight(status: ReportExportStatus): boolean {
  return (
    status === ReportExportStatus.PENDING ||
    status === ReportExportStatus.PROCESSING
  );
}

export function isExportExpired(reportExport: ReportExport): boolean {
  if (!reportExport.expiresAt) return false;
  return new Date() > new Date(reportExport.expiresAt);
}
